"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Listener = void 0;
var Listener = /** @class */ (function () {
    function Listener(owner, event, listener, _internal) {
        if (_internal === void 0) { _internal = false; }
        this.owner = owner;
        this.event = event;
        this.listener = listener;
        this._internal = _internal;
    }
    Listener.prototype.unbind = function () {
        if (this._internal) {
            this.owner.removeInternalListener(this);
        }
        else {
            this.owner.removeListener(this);
        }
    };
    return Listener;
}());
exports.Listener = Listener;
//# sourceMappingURL=Listener.js.map